// eslint-disable react/jsx-props-no-spreading
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import _ from 'lodash';

import { requestUserRoles } from 'services/actions/adminActions';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { requestUserRoles, roles } = rest;
  const isAbleToView =
    _.includes(roles, 'Moderator') ||
    _.includes(roles, 'Admin') ||
    _.includes(roles, 'Customer Service');

  useEffect(() => {
    requestUserRoles();
  }, []);

  if (_.isEmpty(roles)) return null;

  return (
    <Route
      {...rest}
      render={(props) =>
        isAbleToView ? <Component {...props} /> : <Redirect to="/edit" />
      }
    />
  );
};

const mapStateToProps = (state) => ({
  roles: state.adminState.roles,
});

export default connect(mapStateToProps, { requestUserRoles })(PrivateRoute);
